import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense } from "react";
import { theme } from "@/theme";
import { AuthProvider } from "@/hooks/useAuth";
import AuthGuard from "@/components/AuthGuard";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Plugins from "@/pages/Plugins";
import PluginDetail from "@/pages/PluginDetail";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Prompts from "@/pages/Prompts";
import Schedules from "@/pages/Schedules";
import PluginManagement from "@/pages/admin/PluginManagement";
import Credentials from "@/pages/admin/Credentials";
import Settings from "@/pages/admin/Settings";

// Code-split Flow Builder (admin-only, large bundle with @xyflow/react) — NFR-11
const FlowBuilder = lazy(() => import("@/pages/admin/FlowBuilder"));

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/callback" element={<div>Processing login…</div>} />
              <Route
                path="/*"
                element={
                  <AuthGuard>
                    <AppShell>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/plugins" element={<Plugins />} />
                        <Route path="/plugins/:pluginId" element={<PluginDetail />} />
                        <Route path="/jobs" element={<Jobs />} />
                        <Route path="/jobs/:jobId" element={<JobDetail />} />
                        <Route path="/prompts" element={<Prompts />} />
                        <Route path="/schedules" element={<Schedules />} />
                        <Route path="/admin/plugins" element={<PluginManagement />} />
                        <Route path="/admin/flow-builder" element={<Suspense fallback={<div>Loading Flow Builder...</div>}><FlowBuilder /></Suspense>} />
                        <Route path="/admin/credentials" element={<Credentials />} />
                        <Route path="/admin/settings" element={<Settings />} />
                      </Routes>
                    </AppShell>
                  </AuthGuard>
                }
              />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
